import { AddDriver_ValidateFields } from 'components/StraightThroughHouseholdComp/1_Household/Drivers/AddDriverForm/AddDriver_ValidateFields'
import { UpdateDriver_ValidateFields } from 'components/StraightThroughHouseholdComp/1_Household/Drivers/UpdateDriverForm/UpdateDriver_ValidateFields'
import { AddHhm_ValidateFields } from 'components/StraightThroughHouseholdComp/1_Household/HouseholdMembers/AddHhmForm/AddHhm_ValidateFields'
import { UpdateHhm_ValidateFields } from 'components/StraightThroughHouseholdComp/1_Household/HouseholdMembers/UpdateHhmForm/UpdateHhm_ValidateFields'
import { useDriverHHM } from 'components/StraightThroughHouseholdComp/HouseholdContext/DriverHHMContext'
import { useContext, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { storageData } from 'services/Services'
import { ValidateFields } from '../1_NewAddress/ValidateFields'
import { AddressChangeContext } from '../AddressContext/AddressChangeContext'
import { NewAddressContext } from '../AddressContext/NewAddressContext'
import { DriverAssignmentValidation } from '../DriverAssignmentValidation/DriverAssignmentValidation'
import { getValidAddress, submitEndorsement } from 'services/Api'

const AddressChangeBtnNav = () => {
    const navigate = useNavigate()
    const [isSubmitting, setIsSubmitting] = useState(false);
    const addressChangeContext = useContext(AddressChangeContext)
    const newAddressContext = useContext(NewAddressContext)
    const driverHHMContext = useDriverHHM()
    var addressChangeClass = addressChangeContext?.addressChangeClass
    var screen = window.location.pathname.split("/").pop()
    var householdForms = ["Add Driver", "Add Household Member", "Update Driver", "Update HHM"]

    const navigateBack = () => {
        // New Address page
        if (screen == "new-address") {
            // Return to home page
            addressChangeContext?.clear()
            window.location.href = "/home"
        }
        // Household page
        else if (screen == "household") {
            if (householdForms.includes(driverHHMContext?.driverHHM?.componentTracker)) {
                driverHHMContext?.clearDriverHHM();
            }
            else {
                navigate("/endorsement/new-address")
            }
        }
        // Driver Assignment page
        else if (screen == "driver-assignment") {
            navigate("/endorsement/address/household")
        }
        // Confirm page
        else if (screen == "confirm") {
            if (driverAssignmentCheck(driverHHMContext)) {
                navigate("/endorsement/address/driver-assignment")
            }
            else {
                navigate("/endorsement/address/household")
            }
        }
    }

    // Next button component navigation
    const nextButtonNavigate = async () => {
        if (screen == "new-address") {
            setIsSubmitting(true);
            var validationList = await ValidateFields({ context: addressChangeContext, session: newAddressContext?.newAddress, newAddressContext: newAddressContext })

            if (validationList?.length > 0) {
                for (var i = 0; i < validationList.length; i++) {
                    addressChangeContext?.setValidationMsgToggle(validationList[i].title, validationList[i].message)
                    setIsSubmitting(false);
                    return;
                }
                return;
            }

            const data = {
                addrTypeCd: "ContactAddr",
                addr1: newAddressContext?.newAddress.homeAddress,
                city: newAddressContext?.newAddress.city,
                stateProvCd: newAddressContext?.newAddress.state,
                postalCode: newAddressContext?.newAddress.zip,
                regionCd: "US",
                regionISOCd: "US"
            };

            var address = await getValidAddress(data);

            const newAddr = 
            {...newAddressContext?.newAddress,
                county: address.data.addresses[0].county,
                regionCd: address.data.addresses[0].regionCd,
                regionISOCd: address.data.addresses[0].regionISOCd,
                verificationHash: address.data.addresses[0].verificationHash,
                latitude: address.data.addresses[0].latitude,
                longitude: address.data.addresses[0].longitude,
                dpv: address.data.addresses[0].dpv,
                dpvDesc: address.data.addresses[0].dpvDesc,
                dpvNotes: address.data.addresses[0].dpvNotes,
                dpvNotesDesc: address.data.addresses[0].dpvNotesDesc,
                barcodeDigits: address.data.addresses[0].barcodeDigits,
                carrierRoute: address.data.addresses[0].carrierRoute,
                congressCode: address.data.addresses[0].congressCode,
                countyCode: address.data.addresses[0].countyCode,
                block: address.data.addresses[0].block,
                tract: address.data.addresses[0].tract,
                decennialCensusKey: address.data.addresses[0].decennialCensusKey
             }

            // Navigate to household page
            var addressChangeClassCopy = addressChangeClass

            // Save new address to class
            addressChangeClassCopy.newAddress = newAddr;
            addressChangeContext?.setAddressChangeClass({ ...addressChangeClass.newAddress, ...addressChangeClassCopy })
            storageData.setItem("AddressChangeClass", JSON.stringify(addressChangeClassCopy))
            setIsSubmitting(false);
            navigate("/endorsement/address/household")
        }
        else if (screen === "household") {
            // setIsSubmitting(true);
            if (!driverHHMContext?.driverHHM?.componentTracker) {
                navigate("/endorsement/address/confirm")
                return
            }

            var validationList;
            var formVal = { ...handleForm(), componentTracker: driverHHMContext?.driverHHM?.componentTracker }

            // Validate Add Driver
            if (driverHHMContext?.driverHHM?.componentTracker === "Add Driver") {
                validationList = await AddDriver_ValidateFields({ context: addressChangeContext, session: formVal })
            }
            else if (driverHHMContext?.driverHHM?.componentTracker === "Update Driver") {
                validationList = await UpdateDriver_ValidateFields({ context: addressChangeContext, session: formVal })
                var formerVehicles = driverHHMContext?.driverHHM.vehicleInfo.vehiclesAtNewAddress
                const vehiclesAtNewAddress = formVal?.vehicleInfo?.vehiclesAtNewAddress?.map(
                    (x) => formerVehicles.filter(y => y.VIN == x)[0]
                )||[] //Adds whole vehicle object
                formVal = { ...formVal, userInfo: { ...driverHHMContext?.driverHHM?.userInfo }, vehicleInfo: { ...formVal.vehicleInfo, vehiclesAtNewAddress } }
                var storedDrivers = addressChangeContext["addressChangeClass"]?.driverAssignment?.drivers;
                if (storedDrivers && storedDrivers.length > 0) {
                    var driversCopy = storedDrivers;
                    const updatedDriverIndex = storedDrivers.findIndex(driver => driver?.fullName === formVal?.userInfo?.firstName + " " + formVal?.userInfo?.lastName);
                    
                    if(updatedDriverIndex == -1){
                        var updatedInd = storedDrivers.findIndex(driver => (driver?.editType != "" && driver?.editType != null));
                        driversCopy[updatedInd] = formVal;
                    }
                    else{
                        driversCopy[updatedDriverIndex] = formVal;
                    }
                    
                }
            }
            else if (driverHHMContext?.driverHHM?.componentTracker === "Add Household Member") {
                validationList = await AddHhm_ValidateFields({ context: addressChangeContext, session: formVal })
            }
            else if (driverHHMContext?.driverHHM?.componentTracker === "Update HHM") {
                validationList = await UpdateHhm_ValidateFields({ context: addressChangeContext, session: formVal })
                formVal = { ...formVal, userInfo: { ...driverHHMContext?.driverHHM?.userInfo } }
            }

            // Return validation modal if required fields not fulfilled
            if (validationList?.length > 0) {
                for (var i = 0; i < validationList.length; i++) {
                    addressChangeContext?.setValidationMsgToggle(validationList[i].title, validationList[i].message)
                    setIsSubmitting(false);
                    return;
                }
                return;
            }
            formVal = {
                ...formVal,
                driverInfo: {
                    ...(formVal?.driverInfo||{}) ,
                    principalStatus: driverHHMContext?.driverHHM?.driverInfo?.principalStatus
                }
            }
            driverHHMContext.setDriverHHM({ ...formVal })
            var addressChangeClassCopy = driverHHMContext?.SaveFormToClass(addressChangeClass, formVal);

            addressChangeContext?.setAddressChangeClass({ ...addressChangeClassCopy })
            storageData.setItem("AddressChangeClass", JSON.stringify(addressChangeClassCopy))

            // Redirect to driver assignment if added any new drivers (includes converting hhm to driver)
            if (driverAssignmentCheck(driverHHMContext)) {
                var storedDrivers = storageData.getItem("storedDrivers")
                addressChangeClassCopy.driverAssignment.drivers = JSON.parse(storedDrivers)
                addressChangeContext?.setAddressChangeClass({ ...addressChangeClassCopy })
                storageData.setItem("AddressChangeClass", JSON.stringify(addressChangeClassCopy))
                navigate("/endorsement/address/driver-assignment")
            }
            else {
                navigate("/endorsement/address/confirm")
            }
        }
        else if (screen === "driver-assignment") {
            // Validate driver-assignment page
            var validationList = await DriverAssignmentValidation({
                vehicles: addressChangeContext?.addressChangeClass?.driverAssignment?.vehicles,
                drivers: addressChangeContext?.addressChangeClass?.driverAssignment?.drivers
            });

            if (validationList?.length > 0) {
                for (var i = 0; i < validationList.length; i++) {
                    addressChangeContext?.setValidationMsgToggle(validationList[i].title, validationList[i].message)
                    setIsSubmitting(false);
                    return;
                }
                return;
            }

            if (addressChangeClass.driverAssignment.drivers.length<=addressChangeClass.driverAssignment.vehicles.length){
                addressChangeClass.driverAssignment.drivers[addressChangeClass.driverAssignment.drivers.length-1].driverInfo.principalStatus = "Principal";
            }
            else{
                addressChangeClass.driverAssignment.drivers.forEach(driver => {
                    const hasMatchingVehicle = addressChangeClass.driverAssignment.vehicles.some(vehicle =>
                        vehicle.driverDLN === driver?.driverInfo?.licenseNumber || vehicle.driverDLN === driver?.licenseNum
                    );
                    if(driver?.currStatus){
                        driver.currStatus = hasMatchingVehicle ? "Principal" : "Occasional";
                    }
                    else{
                        driver.driverInfo.principalStatus = hasMatchingVehicle ? "Principal" : "Occasional";
                    }
                });
            }

            // Save to class
            var addressChangeClassCopy = addressChangeClass;
            addressChangeContext?.setAddressChangeClass({ ...addressChangeClassCopy })
            storageData.setItem("AddressChangeClass", JSON.stringify(addressChangeClassCopy))

            navigate("/endorsement/address/confirm")
        }
        else if (screen === "confirm") {
            setIsSubmitting(true);

            if (!addressChangeContext?.addressChangeClass?.confirmation) {
                addressChangeContext.setValidationMsgToggle("Oops!", "Please certify that the answers to the questions listed in the change are true and accurate to the best of your knowledge to submit your request.")
                setIsSubmitting(false);
                return;
            }

            // Send endorsement class to backend
            var req = {
                "requestType": "Address Change",
                "classRequest": storageData.getItem("AddressChangeClass")
            }
            setIsSubmitting(true);
            addressChangeContext?.setSubmissionLoad(true); 
            // Display spinner and hide nav buttons

            // Api call to send data
            try {
                const response = await submitEndorsement(req);
                storageData.setItem("responseData", JSON.stringify(response.data));
                // const response = ""
                redirectWithRemoves(response?.data?.requestStatus)
                // navigate("/endorsement/address/address-summary")

            } catch (error) {
                console.error("Error submitting endorsement:", error);
                addressChangeContext.setSubmitEndorsementResponse({ error: true, message: "An error occurred while submitting the endorsement." });
            } finally {
                setIsSubmitting(false);
                addressChangeContext?.setSubmissionLoad(false); // Hide spinner and display nav buttons
            }
        }
    }

    // Removes last 2 pages from history stack to allow back button to home
    const redirectWithRemoves = (status) => {
        window.history.pushState(null, null, window.location.href);
        window.history.go(-2);
        window.history.replaceState(null, null, window.location.href);

        if (status == "Failed") {
            window.location.replace('/endorsement/address/address-fail')
        }
        else if (status == "Blocked") {
            window.location.replace('/endorsement/address/address-block')
        }
        else {
            window.location.replace('/endorsement/address/address-summary');
        }
    }

    return (
        <>
            <div className="mt-2 mb-3">
                <div>
                    {!isSubmitting &&
                        <>
                            {/* Back Button */}
                            <button type="button" className="btn btn-default editCancelBtn" onClick={() => { navigateBack() }}>
                                BACK
                            </button>
                            {/* Continue Button */}
                            <button type="submit" className="btn btn-primary-grad right pull-right editCancelBtn" onClick={() => { nextButtonNavigate() }}>
                                {screen == "confirm" ? "SUBMIT" : "NEXT"}
                            </button>
                        </>
                    }
                    {/* Spinner for retrieving vehicle info from vin */}
                    {isSubmitting &&
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    }

                </div>
            </div>
        </>
    )
}

const handleForm = () => {
    const formValues = {};
    // Get all form elements (including those missing from FormData)
    document.querySelectorAll("input, select, textarea").forEach(input => {
        if (input.type === "checkbox") {
            formValues[input.name] = [...(formValues[input.name] || []), ...(input.checked ? [input.value] : [])];
        } else if (input.type === "radio") {
            if (!formValues[input.name]) {
                formValues[input.name] = (input.checked) ? input.value : ""; // Empty if no radio is selected
            }
        } else {
            formValues[input.name] = input.value || "";
        }
    });
    const formValuesReformatted = nestObject(formValues)
    return formValuesReformatted
}

function nestObject(obj) {
    let result = {};

    for (let key in obj) {
        if (key.includes("_")) {
            let [parent, child] = key.split("_");

            if (!result[parent]) {
                result[parent] = {};
            }

            result[parent][child] = obj[key];
        } else {
            result[key] = obj[key];
        }
    }

    return result;
}

const driverAssignmentCheck = (driverHHMContext) => {
    // Added driver form completed
    if (driverHHMContext?.driverHHM?.componentTracker === "Add Driver") return true;
    // Added household member as a driver
    else if (driverHHMContext?.driverHHM?.componentTracker === "Add Household Member" &&
        driverHHMContext?.calculateAge(driverHHMContext?.driverHHM?.userInfo?.dobMonth, driverHHMContext?.driverHHM?.userInfo?.dobDay, driverHHMContext?.driverHHM?.userInfo?.dobYear) >= 16 &&
        driverHHMContext?.driverHHM?.driverInfo?.ownInsurance === "0")
        return true;
    // Updated household member "As a Driver"
    else if (driverHHMContext?.driverHHM?.componentTracker === "Update HHM" && driverHHMContext?.driverHHM?.editType === "Add as driver on policy.") return true;
    else return false;
}

export default AddressChangeBtnNav